module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/dog-pool-581.ebe279a8c368d609.png"+" 581w",
        images: [{path: "https://static.sniffspot.com/packs/img/dog-pool-581.ebe279a8c368d609.png",width: 581,height: 400}],
        src: "https://static.sniffspot.com/packs/img/dog-pool-581.ebe279a8c368d609.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/dog-pool-581.ebe279a8c368d609.png"},
        
        width: 581,
        height: 400
      }